import { useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { useRouter } from 'next/router';
import { PaymentFormContext } from '../../PaymentFormContext';

export default function useExistingPaymentMethodForm({
  paymentMethods,
  subscriptionTypeId,
  amount,
  subscriptionParams,
  promotionCode,
}) {
  const paymentFormContext = useContext(PaymentFormContext);
  const router = useRouter();
  const { state, actions } = useCustomHook({
    defaultState: {
      selectedPaymentMethodId: null,
      processing: false,
      error: null,
    },
    actions: {
      setSelectedPaymentMethodId: (selectedPaymentMethodId) => {
        actions.setState({ selectedPaymentMethodId });
      },
      pay: async () => {
        actions.setState({ processing: true, error: null });

        try {
          const subscriptionPayment =
            await paymentFormContext.actions.createSubscriptionPayment({
              subscriptionTypeId,
              amount,
              subscriptionParams,
              paymentMethodId: state.selectedPaymentMethodId,
              couponCode: promotionCode?.code,
            });

          const successUrl =
            paymentFormContext.actions.onPaymentCompletedUrl(
              subscriptionPayment
            );

          router.push(successUrl);

          paymentFormContext.actions.onPaymentCompleted();
          actions.setState({ processing: false });
        } catch (e) {
          actions.setState({
            processing: false,
            error: e.response?.data?.message || e.message,
          });
        }
      },
      closeError: () => {
        actions.setState({ error: null });
      },
    },
  });

  useEffect(() => {
    actions.setState({
      selectedPaymentMethodId: paymentMethods?.length
        ? paymentMethods[0].id
        : null,
    });
  }, [paymentMethods]);

  return { state, actions };
}
